import React, { useMemo } from 'react'
import { useApiFormNodeCourse, useApiFormNodeMove, useApiListNodeCourse, useApiListNodeCourseCategory } from '../../../../../../api-new/state/content'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { IconMove } from '../../../../../../shared/icon/icon'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { CourseMenu } from '../../common/menu/node-actions'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { FormSimple } from '../../../../../../shared/form-simple/form'
import { FormSimpleHiddenNumber } from '../../../../../../shared/form-simple/form-hidden-number'
import { FormSimpleSubmitEdit } from '../../../../../../shared/form-simple/form-submit'
import { buildContentCoursePath } from '../../common/shared/build-path'
import { FormSimpleCategorySelectFilter } from '../../../../../../shared/form-simple/form-category-select-filter'

export const NodeCourseMove = ({ parentURL, nodeID }) => {
  const history = useHistory()

  const apiFormNodeCourse = useApiFormNodeCourse()
  const apiFormNodeMove = useApiFormNodeMove()
  const apiListNodeCourse = useApiListNodeCourse()

  const title = useMemo(() => apiFormNodeCourse.form.name, [apiFormNodeCourse.form])

  const handleMatch = async () => {
    await apiFormNodeCourse.get(nodeID)
  }

  const handleSubmit = async data => {
    await apiFormNodeMove.put(data.nodeID, data)
    const nodes = await apiListNodeCourse.get(`ancestors/${data.nodeID}`)
    const path = buildContentCoursePath(nodes, data.nodeID)
    history.replace(path)
  }

  const HeaderMenu = () => <CourseMenu place="header" url={parentURL} node={apiFormNodeCourse.form} nodeID={nodeID} />

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconMove} text="Move" onMatch={handleMatch}>
        <CardFullHeightScrollY title={title} HeaderMenu={HeaderMenu}>
          <FormSimple onSubmit={handleSubmit}>
            <FormSimpleHiddenNumber name="nodeID" value={apiFormNodeCourse.form.id} required />
            <FormSimpleCategorySelectFilter name="parentID" label="category" rootName="COURSE" useApiListCategory={useApiListNodeCourseCategory} required />
            <FormSimpleSubmitEdit text="move course" backURL={parentURL} />
          </FormSimple>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
